import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
import ActionBar from '../../components/ActionBar';
import Fieldset from '../Fieldset';
import Input from '../Input';
import {Content} from './styles';
import DataNotice from "./components/DataNotice";

function CustomerInfo({t, data, setData, resetErrors, errors}) {
  const [nextDisabled, disableNext] = useState(true);

  useEffect(() => {
    disableNext(!(data.contactName && data.legalOwnerName && data.outletType && data.contactPhone && data.contactEmail && data.contactEmailConfirmation) || (data.season === 'event' && data.eventStartDate === '') || (data.season === 'event' && data.eventEndDate === ''));
  });

  function handleNext() {
    if (data.invoiceEmail === '') {
      setData({invoiceEmail: data.contactEmail});
    }
    if (data.paymentRemindersEmail === '') {
      setData({paymentRemindersEmail: data.contactEmail});
    }
    return true;
  }

  function handlePrev() {
    return true;
  }

  function handleChange({target: {name, value}}) {
    setData({[name]: value});
  }

  function handleSeason({target: {value}}) {
    setData({season: value});
  }

  return (
    <div>
      <Content>
        <Fieldset legend={t('form.legends.customerInfo')}>
          <Input
            id="companyFriendlyName"
            type="text"
            value={data.companyFriendlyName}
            error={errors.companyFriendlyName}
            onChange={handleChange}
            tooltipInfo={t('form.companyFriendlyName.info')}
          />
          <Input
            id="legalOwnerName"
            type="text"
            value={data.legalOwnerName}
            error={errors.legalOwnerName}
            onChange={handleChange}
          />
          <Input
            id="outletType"
            type="text"
            value={data.outletType}
            error={errors.outletType}
            onChange={handleChange}
          />
          <Input
            id="contactName"
            type="text"
            value={data.contactName}
            error={errors.contactName}
            onChange={handleChange}
          />
            
          <Input
            id="contactPhone"
            type="text"
            value={data.contactPhone}
            error={errors.contactPhone}
            onChange={handleChange}
          />
            
          <Input
            id="contactEmail"
            type="text"
            value={data.contactEmail}
            error={errors.contactEmail}
            onChange={handleChange}
            tooltipInfo={t('form.contactEmail.info')}
          />
            
          <Input
            id="contactEmailConfirmation"
            type="text"
            value={data.contactEmailConfirmation}
            error={errors.contactEmailConfirmation}
            onChange={handleChange}
            disablePasting={true}
          />
          
          <p>
            {t('form.season.label')}
          </p>
          
          <div className="form-control" id="season">
            <input
              id="seasonFullYear"
              type="radio"
              value="fullYear"
              onChange={handleSeason}
              checked={data.season === 'fullYear'}
            />
            <label htmlFor="seasonFullYear">
              {t('form.seasons.fullYear')}
            </label>

            <input
              id="seasonWinter"
              type="radio"
              value="winter"
              onChange={handleSeason}
              checked={data.season === 'winter'}
            />
            <label htmlFor="seasonWinter">
              {t('form.seasons.winter')}
            </label>

            <input
              id="seasonSummer"
              type="radio"
              value="summer"
              onChange={handleSeason}
              checked={data.season === 'summer'}
            />
            <label htmlFor="seasonSummer">
              {t('form.seasons.summer')}
            </label>

            <input
              id="seasonEvent"
              type="radio"
              value="event"
              onChange={handleSeason}
              checked={data.season === 'event'}
            />
            <label htmlFor="seasonEvent">
              {t('form.seasons.event')}
            </label>
          </div>

          {
            data.season === 'event'
              ? (
                <div style={{marginTop: '1.5rem'}}>
                  <p>
                    {t('form.eventDatesMessage')}
                  </p>
                  <Input
                    id="eventStartDate"
                    type="date"
                    value={data.eventStartDate}
                    error={errors.eventStartDate}
                    onChange={handleChange}
                  />
                  <Input
                    id="eventEndDate"
                    type="date"
                    value={data.eventEndDate}
                    error={errors.eventEndDate}
                    onChange={handleChange}
                  />
                </div>
              )
              : null
          }

          <DataNotice/>
        </Fieldset>
      </Content>

      <ActionBar
        onPrev={handlePrev}
        onNext={handleNext}
        nextDisabled={nextDisabled}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  errors: state.signup.errors
});

const mapDispatchToProps = dispatch => ({
  setData: data => dispatch({type: 'SET_DATA', payload: data}),
  resetErrors: () => dispatch({type: 'RESET_ERRORS'})
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(CustomerInfo)
);